import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {ApiConfig} from './api-config';
import {catchError, map, Observable, of, shareReplay} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  isSignedIn$: Observable<boolean> | null = null;

  constructor(private http: HttpClient) {
  }

  public refreshToken(): Observable<boolean> {
    return this.http.patch<{refreshed_tokens: string[]}>(ApiConfig.getApiUrl('/authenticate/refresh.json'), {}).pipe(
      map(response => response.refreshed_tokens.includes('administrator')),
      catchError(error => of(error.status !== 401))
    );
  }

  public clearIsSignedInCache(): void {
    this.isSignedIn$ = null;
  }

  public hasSignedIn(): boolean {
    return !!this.isSignedIn$;
  }

  public isSignedIn(): Observable<boolean> {
    if(this.isSignedIn$) {
      return this.isSignedIn$;
    }
    this.isSignedIn$ = this.http.get<void>(ApiConfig.getApiUrl('/administrators/current.json')).pipe(
      map(() => true),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          return of(false);
        }
        // For other errors, propagate the error
        throw error;
      }),
      // Cache the result
      shareReplay(1)
    );
    return this.isSignedIn$;
  }

  public signOut(): Observable<void> {
    this.clearIsSignedInCache()
    return this.http.delete<void>(ApiConfig.getApiUrl('/authenticate/administrator.json'));
  }
}
